// AR UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'شقق وفنادق',
  'site.currency': 'العملة',
  'site.language': 'اللغة',
  'site.currencySelector': 'محدد العملة',
  'site.languageSelector': 'محدد اللغة',
  'site.menu': 'القائمة',
  'site.signIn': 'تسجيل الدخول',
  'site.signOut': 'تسجيل الخروج',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'فتح القائمة',
  'site.footer.copyright': 'جميع الحقوق محفوظة.',
  'site.footer.manageBooking': 'إدارة حجزك',
  'site.footer.terms': 'الشروط والأحكام',
  'site.footer.privacy': 'سياسة الخصوصية',
  'site.trust.bestPrice': 'ضمان أفضل سعر',
  'site.trust.bestPriceDesc': 'احصل على أفضل الأسعار.',
  'site.trust.flexibleBooking': 'حجز مرن',
  'site.trust.flexibleBookingDesc': 'تغيير وإلغاء سهل.',
  'site.trust.securePayments': 'مدفوعات آمنة',
  'site.trust.securePaymentsDesc': 'دفع آمن وموثوق.',
  'site.trust.localSupport': 'دعم محلي',
  'site.trust.localSupportDesc': 'نحن هنا للمساعدة في أي وقت.',
  'home.heroTitle': 'اعثر على إقامتك المثالية',
  'home.inAustralia': 'في أستراليا',
  'home.heroSubtitle': 'شقق وفنادق لكل نوع من الإقامات',
  'home.errorLoading': 'تعذر تحميل العقارات.',
  'home.noPropertiesTitle': 'لا توجد عقارات متاحة حالياً.',
  'home.noPropertiesDescription': 'جرّب البحث عن وجهة لاستكشاف الإقامات المتاحة.',
  'home.exploreStays': 'استكشف الإقامات',
  'home.property': 'عقار',
  'home.property_one': 'عقار',
  'home.property_other': 'عقارات',
  'home.properties': 'عقارات',
  'home.foundInAustralia': 'في أستراليا',
  'search.errorLoading': 'تعذر تحميل التوافر. يرجى المحاولة مرة أخرى.',
  'search.noResults': 'لا توجد عقارات تطابق معايير بحثك.',
  'search.mapFollow': 'ابحث مع تحريك الخريطة',
  'search.chooseLocationTitle': 'اختر موقعاً',
  'search.chooseLocationDescription': 'اختر وجهة قبل البحث عن الإقامات المتاحة.',
  'search.chooseDatesTitle': 'اختر تواريخك',
  'search.pastCheckIn': 'لا يمكن أن يكون تاريخ الوصول في الماضي.',
  'search.checkOutAfterCheckIn': 'يجب أن يكون تاريخ المغادرة بعد تاريخ الوصول.',
  'search.property': 'عقار',
  'search.property_one': 'عقار',
  'search.property_other': 'عقارات',
  'search.properties': 'عقارات',
  'search.found': 'تم العثور',
  'widget.where': 'المكان',
  'widget.location': 'الموقع',
  'widget.checkInOut': 'الوصول / المغادرة',
  'widget.guests': 'النزلاء',
  'widget.rooms': 'الغرف',
  'widget.promoCode': 'رمز العرض',
  'widget.promoPlaceholderCompact': 'أضف الرمز (اختياري)',
  'widget.promoPlaceholder': 'اختياري',
  'widget.search': 'بحث',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'بالغ',
  'widget.adults': 'بالغون',
  'widget.child': 'طفل',
  'widget.children': 'أطفال',
  'widget.decreaseAdults': 'تقليل عدد البالغين',
  'widget.increaseAdults': 'زيادة عدد البالغين',
  'widget.decreaseChildren': 'تقليل عدد الأطفال',
  'widget.increaseChildren': 'زيادة عدد الأطفال',
  'widget.room': 'غرفة',
  'widget.adultOption': '{count} بالغين',
  'widget.adultOption_one': '{count} بالغ',
  'widget.adultOption_other': '{count} بالغين',
  'widget.childOption': '{count} أطفال',
  'widget.childOption_one': '{count} طفل',
  'widget.childOption_other': '{count} أطفال',
  'widget.roomOption': '{count} غرف',
  'widget.roomOption_one': '{count} غرفة',
  'widget.roomOption_other': '{count} غرف',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'تعذر تحميل المواقع. يرجى المحاولة مرة أخرى.',
  'widget.searchAria': 'البحث عن التوافر',
  'widget.dateErrorRequired': 'يرجى تحديد تاريخي الوصول والمغادرة.',
  'widget.dateErrorPast': 'لا يمكن أن يكون تاريخ الوصول في الماضي.',
  'widget.dateErrorRange': 'يجب أن يكون تاريخ المغادرة بعد تاريخ الوصول.',
  'widget.dateRange.placeholder': 'حدد تواريخ الوصول والمغادرة',
  'widget.dateRange.selectCheckout': 'اختر تاريخ المغادرة',
  'widget.dateRange.aria.checkIn': 'الوصول',
  'widget.dateRange.aria.checkOut': 'المغادرة',
  'widget.dateRange.aria.picker': 'منتقي نطاق تاريخ الوصول / المغادرة',
  'widget.dateRange.previousMonth': 'الشهر السابق',
  'widget.dateRange.nextMonth': 'الشهر التالي',
  'widget.dateRange.selectCheckIn': 'حدد تاريخ الوصول',
  'widget.dateRange.selectCheckOut': 'حدد تاريخ المغادرة',
  'widget.dateRange.resetToday': 'إعادة تعيين إلى اليوم',
  'widget.dateRange.done': 'تم',
  'property.heroAlt': 'صورة العقار الرئيسية',
  'property.fallbackName': 'عقار مختار من {site}',
  'property.chooseRoom': 'اختر غرفتك',
  'property.filterBy': 'تصفية حسب:',
  'property.filterAll': 'جميع الغرف',
  'property.filterStudios': 'استوديوهات',
  'property.filter1Bed': 'غرفة نوم واحدة',
  'property.filter2Bed': 'غرفتا نوم',
  'property.filterApartments': 'شقق',
  'property.sortBy': 'ترتيب حسب:',
  'property.sortRecommended': 'موصى به',
  'property.sortPriceLow': 'السعر: من الأقل إلى الأعلى',
  'property.sortPriceHigh': 'السعر: من الأعلى إلى الأقل',
  'property.errorLoading': 'تعذر تحميل التوافر. يرجى المحاولة مرة أخرى.',
  'property.noRooms': 'لا توجد غرف متاحة',
  'property.noRoomsDescription': 'جرّب تواريخ أو عدد نزلاء مختلفين.',
  'property.totalForNights': 'المجموع لـ {nights} ليالٍ',
  'property.perNight': 'لليلة الواحدة',
  'property.night': 'ليلة',
  'property.night_one': 'ليلة',
  'property.night_other': 'ليالٍ',
  'property.nights': 'ليالٍ',
  'property.freeCancellation': 'إلغاء مجاني',
  'property.selectRoom': 'اختر الغرفة',
  'property.selected': 'تم الاختيار',
  'property.continue': 'متابعة',
  'property.previousPhoto': 'الصورة السابقة',
  'property.nextPhoto': 'الصورة التالية',
  'property.addToWishlist': 'أضف إلى المفضلة',
  'property.popularChoice': 'الاختيار الأكثر شيوعاً',
  'property.showMore': 'عرض المزيد',
  'property.showLess': 'عرض أقل',
  'property.maxOccupancy': 'الحد الأقصى للإشغال:',
  'property.size': 'المساحة:',
  'property.bedType': 'نوع السرير:',
  'property.roomAmenities': 'مرافق الغرفة',
  'property.showMoreAmenities': '+{count} أخرى',
  'property.guests': 'النزلاء',
  'property.adults': 'بالغون',
  'property.children': 'أطفال',
  'property.onlyRoomsLeft': 'متبقية {count} غرف فقط',
  'property.onlyRoomsLeft_one': 'متبقية {count} غرفة فقط',
  'property.onlyRoomsLeft_other': 'متبقية {count} غرف فقط',
  'property.lastBookedMinutes': 'آخر حجز قبل {count} دقيقة',
  'property.lastBookedMinutes_one': 'آخر حجز قبل {count} دقيقة',
  'property.lastBookedMinutes_other': 'آخر حجز قبل {count} دقيقة',
  'property.lastBookedHours': 'آخر حجز قبل {count} ساعة',
  'property.lastBookedHours_one': 'آخر حجز قبل {count} ساعة',
  'property.lastBookedHours_other': 'آخر حجز قبل {count} ساعة',
  'property.lastBookedDays': 'آخر حجز قبل {count} يوم',
  'property.lastBookedDays_one': 'آخر حجز قبل {count} يوم',
  'property.lastBookedDays_other': 'آخر حجز قبل {count} يوم',
  'property.checkInTime': 'الوصول {time}',
  'property.checkOutTime': 'المغادرة {time}',
  'property.compare': 'قارن',
  'property.taxesIncluded': 'لليلة شاملة الضرائب والرسوم',
  'property.chooseRate': 'اختر الأسعار',
  'property.yourSelection': 'اختيارك',
  'property.aboutRoom': 'حول هذه الغرفة',
  'property.roomDetails': 'تفاصيل الغرفة',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'العودة إلى الغرف',
  'property.standardRate': 'السعر القياسي',
  'property.noPromotion': 'لا يوجد عرض لهذا السعر.',
  'property.youSave': 'وفر ({percent}%) - {amount}',
  'property.inclusions': 'المشتملات:',
  'property.viewAllPhotos': 'عرض جميع الصور',
  'property.seeOnMap': 'عرض على الخريطة',
  'room.perNight': 'ليلة',
  'room.sleeps': 'تسع لـ',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'متاح',
  'room.select': 'اختر',
  'room.selected': 'تم الاختيار',
  'card.viewAvailability': 'عرض التوافر',
  'card.from': 'ابتداءً من',
  'card.night': 'ليلة',
  'card.checkAvailability': 'تحقق من التوافر',
  'card.saveToFavourites': 'حفظ في المفضلة',
  'card.ratingExcellent': 'ممتاز',
  'card.ratingVeryGood': 'جيد جداً',
  'card.ratingGood': 'جيد',
  'card.ratingGuest': 'تقييم النزلاء',
  'guest.stepChooseRoom': 'اختر الغرفة',
  'guest.stepGuestDetails': 'تفاصيل النزيل',
  'guest.stepPayment': 'الدفع',
  'guest.stepConfirmation': 'التأكيد',
  'guest.title': 'أدخل تفاصيل النزيل',
  'guest.subtitle': 'يرجى تقديم معلوماتك.',
  'guest.firstName': 'الاسم الأول',
  'guest.lastName': 'اسم العائلة',
  'guest.email': 'البريد الإلكتروني',
  'guest.emailHint': 'سيتم إرسال تأكيد الحجز إلى هذا البريد الإلكتروني.',
  'guest.country': 'الدولة',
  'guest.selectCountry': 'اختر الدولة',
  'guest.searchCountry': 'البحث في الدول…',
  'guest.loadingCountries': 'جارٍ تحميل الدول…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'الرمز البريدي',
  'guest.phone': 'رقم الهاتف',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'أدخل رقم الهاتف',
  'guest.address': 'العنوان',
  'guest.city': 'المدينة',
  'guest.specialRequests': 'طلبات خاصة (اختياري)',
  'guest.specialRequestsPlaceholder': 'هل لديك طلبات خاصة؟',
  'guest.termsPrefix': 'بإتمام هذا الحجز، أوافق على',
  'guest.terms': 'الشروط والأحكام',
  'guest.termsAnd': 'و',
  'guest.privacy': 'سياسة الخصوصية',
  'guest.termsSuffix': '، وأوافق على شروط الحجز.',
  'guest.marketingOptOut': 'لا أرغب في تلقّي رسائل تسويقية.',
  'guest.cardVerify':
    'سيتم إجراء تحقق مؤقت بقيمة 1 {currency} على البطاقة. لن يتم خصم المبلغ الآن.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'سيتم تحصيل الدفع في العقار.',
  'guest.noRoomsSelected': 'لم يتم اختيار غرف.',
  'guest.noPropertySelected': 'لم يتم اختيار عقار.',
  'guest.paymentStillLoading': 'خيارات الدفع لا تزال تحمّل. يرجى المحاولة مرة أخرى بعد قليل.',
  'guest.submitProcessing': 'جارٍ المعالجة…',
  'guest.submitVerifyCard': 'تحقق من البطاقة وتأكيد الحجز',
  'guest.submitConfirm': 'تأكيد الحجز',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'الدفع',
  'payment.method': 'طريقة الدفع',
  'payment.cardDetailsHint':
    'أدخل بيانات بطاقتك بأمان أدناه. يتم تشفير بيانات البطاقة ولا تصل إلى خوادمنا.',
  'payment.loadingForm': 'جارٍ تحميل نموذج الدفع…',
  'payment.formUnavailable': 'نموذج الدفع غير متاح.',
  'payment.acceptTerms': 'أوافق على الشروط والأحكام وسياسة الإلغاء.',
  'payment.payNow': 'ادفع الآن',
  'payment.processing': 'جارٍ المعالجة…',
  'payment.noRoomsSelected': 'لم يتم اختيار غرف.',
  'payment.redirecting': 'جارٍ التحويل إلى صفحة الدفع الآمنة…',
  'payment.notConfigured': 'Quickstream غير مُعدّ لهذا العقار.',
  'payment.noScript': 'تعذر تحميل خدمة الدفع Quickstream. يرجى تحديث الصفحة.',
  'payment.formNotLoaded': 'لم يتم تحميل نموذج الدفع. يرجى تحديث الصفحة.',
  'payment.cardDetails': 'فشل الدفع. يرجى التحقق من بيانات بطاقتك.',
  'payment.tokenizationFailed': 'فشل تشفير البطاقة. يرجى المحاولة مرة أخرى.',
  'payment.failed': 'فشل الدفع.',
  'payment.statusResult': 'حالة الدفع: {status}. يرجى المحاولة مرة أخرى.',
  'confirmation.loading': 'جارٍ تحميل حجزك…',
  'confirmation.notFound': 'لم يُعثر على الحجز. تحقق من رقم مرجع الحجز وحاول مرة أخرى.',
  'confirmation.errorGeneric': 'تعذر تأكيد حجزك. يرجى التواصل مع الدعم.',
  'confirmation.errorLoadDetails': 'تعذر تحميل تفاصيل الحجز.',
  'confirmation.couldNotComplete': 'تعذر إكمال دفعك',
  'confirmation.startNew': 'ابدأ حجزاً جديداً',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': 'تعذر العثور على جلسة الدفع. يرجى التواصل مع الدعم.',
  'confirmation.paymentStateInvalid': 'الدفع ليس في حالة صالحة للإكمال. يرجى البدء من جديد.',
  'confirmation.paymentFailedDeclined':
    'تعذر إكمال الدفع. يرجى التحقق من بيانات بطاقتك والمحاولة مرة أخرى، أو استخدام طريقة دفع مختلفة.',
  'confirmation.paymentTimeout': 'استغرق الدفع وقتاً طويلاً. يرجى المحاولة مرة أخرى.',
  'confirmation.paymentGatewayUnavailable': 'نظام الدفع غير متاح مؤقتاً. يرجى المحاولة بعد لحظات.',
  'confirmation.paymentUnknown': 'تعذر تأكيد الدفع: {message}.',
  'confirmation.paymentGenericError':
    'تعذر تأكيد الدفع. يرجى المحاولة مرة أخرى أو التواصل مع الدعم.',
  'summary.title': 'ملخص حجزك',
  'summary.yourBooking': 'ملخص حجزك',
  'summary.noRoomsSelected': 'لم يتم اختيار غرف بعد.',
  'summary.checkIn': 'الوصول',
  'summary.checkOut': 'المغادرة',
  'summary.lengthOfStay': 'مدة الإقامة',
  'summary.guests': 'النزلاء',
  'summary.nights': '{nights} ليالٍ',
  'summary.nights_one': '{nights} ليلة',
  'summary.nights_other': '{nights} ليالٍ',
  'summary.totalForNights': 'المجموع لـ {nights} ليالٍ',
  'summary.includingTaxes': 'شامل الضرائب والرسوم',
  'summary.discount': 'وفر {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'تم تأكيد الحجز!',
  'detail.received': 'تم استلام الحجز',
  'detail.referenceIntro': 'مرجع حجزك هو',
  'detail.reservationId': 'رقم الحجز:',
  'detail.processing': 'جارٍ معالجة حجزك. ستتلقى بريداً إلكترونياً للتأكيد بمجرد تأكيد الدفع.',
  'detail.guest': 'نزيل',
  'detail.rooms': 'الغرف',
  'detail.night': 'ليلة',
  'detail.nights': 'ليالٍ',
  'detail.adult': 'بالغ',
  'detail.adults': 'بالغون',
  'detail.child': 'طفل',
  'detail.infant': 'رضيع',
  'detail.priceBreakdown': 'تفاصيل السعر',
  'detail.subtotal': 'المجموع الفرعي',
  'detail.taxes': 'الضرائب',
  'detail.fees': 'الرسوم',
  'detail.discounts': 'الخصومات',
  'detail.surcharge': 'رسوم إضافية على البطاقة',
  'detail.grandTotal': 'المجموع الكلي',
  'priceBreakdown.roomSubtotal': 'المجموع الفرعي للغرفة',
  'priceBreakdown.total': 'المجموع',
  'detail.deposit': 'العربون',
  'detail.depositDueBy': 'مستحق بحلول',
  'detail.arrival': 'الوصول',
  'detail.specialRequests': 'طلبات خاصة',
  'detail.backToHome': 'العودة إلى الرئيسية',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'إعادة المحاولة',
  'shared.close': 'إغلاق',
  'shared.back': 'رجوع',
  'shared.previous': 'السابق',
  'shared.next': 'التالي',
  'validation.firstNameRequired': 'الاسم الأول مطلوب',
  'validation.lastNameRequired': 'اسم العائلة مطلوب',
  'validation.emailRequired': 'بريد إلكتروني صالح مطلوب',
  'validation.phoneRequired': 'رقم الهاتف مطلوب',
  'validation.addressRequired': 'العنوان مطلوب',
  'validation.cityRequired': 'المدينة مطلوبة',
  'validation.countryRequired': 'الدولة مطلوبة',
  'validation.postalCodeRequired': 'الرمز البريدي مطلوب',
  'error.pmsUnavailable':
    'عذراً، لم تعد هذه الغرفة متاحة للتواريخ المختارة. يرجى العودة واختيار تواريخ أخرى أو غرفة أخرى.',
  'error.pmsSyncError': 'تعذر الاتصال بنظام العقار. يرجى المحاولة بعد لحظات.',
  'error.paymentNotConfigured':
    'الدفع غير مُعدّ لهذا العقار. يرجى اختيار عقار آخر أو التواصل مع الدعم.',
  'error.paymentStartFailed': 'حدث خطأ ما عند بدء الدفع. يرجى المحاولة مرة أخرى.',
  'error.bookingFailed': 'فشل الحجز. يرجى المحاولة مرة أخرى.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'احجز إقامتك',
  'site.title.suffix': 'شقق وفنادق',
  'site.title.home': 'الرئيسية',
  'site.title.search': 'البحث',
  'site.title.property': 'العقار',
  'site.title.room': 'الغرفة',
  'site.title.guestDetails': 'تفاصيل النزيل',
  'site.title.payment': 'الدفع',
  'site.title.confirmation': 'تم تأكيد الحجز',
  'site.title.bookingLookup': 'ابحث عن حجزك',
  'site.title.bookingDetails': 'تفاصيل الحجز',
  'site.title.cancellation': 'إلغاء الحجز',
  'site.title.reservationDetail': 'تفاصيل الحجز',
  'site.title.signIn': 'تسجيل الدخول',
  'site.title.signUp': 'إنشاء حساب',
  'site.title.notFound': 'الصفحة غير موجودة',
  'notFound.title': 'الصفحة غير موجودة',
  'notFound.message': 'الصفحة التي تبحث عنها غير موجودة.',
  'notFound.backHome': 'العودة إلى الرئيسية',
  'home.heroAlt': 'أفق مدينة أستراليا',
  'home.featuredProperties': 'عقارات مميزة',
  'home.popularDestinations': 'وجهات شائعة',
  'common.reviews': '{count} تقييمات',
  'common.reviews_one': '{count} تقييم',
  'common.reviews_other': '{count} تقييمات',
  'common.loading': 'جارٍ التحميل',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'من',
  'common.select': 'اختر…',
  'common.search': 'ابحث…',
  'common.selectLocation': 'اختر موقعاً',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'لا توجد خيارات متاحة',
  'common.code': 'الرمز',
  'common.searchCode': 'ابحث عن رمز…',
  'filter.title': 'عوامل التصفية',
  'filter.price': 'السعر',
  'filter.priceMinimum': 'الحد الأدنى',
  'filter.priceMaximum': 'الحد الأقصى',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'نوع العقار',
  'filter.propertyType.hotel': 'فندق',
  'filter.propertyType.apartment': 'شقة',
  'filter.propertyType.resort': 'منتجع',
  'filter.amenities': 'المرافق',
  'filter.amenity.pool': 'مسبح',
  'filter.amenity.parking': 'موقف سيارات',
  'filter.amenity.breakfast': 'الإفطار مشمول',
  'filter.rating': 'التقييم',
  'filter.rating.any': 'أي تقييم',
  'filter.rating.5': '5 نجوم',
  'filter.rating.4': '4 نجوم فأعلى',
  'filter.rating.3': '3 نجوم فأعلى',
  'filter.more': 'المزيد',
  'filter.more.freeCancellation': 'إلغاء مجاني',
  'filter.more.payAtProperty': 'الدفع في العقار',
  'filter.clear': 'مسح',
  'filter.apply': 'تطبيق عوامل التصفية',
  'card.reviews_one': 'تقييم',
  'card.reviews_other': 'تقييمات',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'الأعمار من 0 إلى 12',
  'auth.orContinueWith': 'أو تابع باستخدام',
  'auth.signIn.title': 'تسجيل الدخول إلى حسابك',
  'auth.signIn.subtitle':
    'أهلاً بعودتك! سجّل الدخول لإدارة حجوزاتك وعرض إقاماتك والحصول على عروض حصرية.',
  'auth.email': 'البريد الإلكتروني',
  'auth.emailPlaceholder': 'أدخل بريدك الإلكتروني',
  'auth.emailRequired': 'البريد الإلكتروني مطلوب.',
  'auth.emailInvalid': 'يرجى إدخال بريد إلكتروني صالح.',
  'auth.password': 'كلمة المرور',
  'auth.passwordPlaceholder': 'أدخل كلمة المرور',
  'auth.createPasswordPlaceholder': 'أنشئ كلمة مرور',
  'auth.passwordRequired': 'كلمة المرور مطلوبة.',
  'auth.passwordMinLength': 'يجب أن تتكون كلمة المرور من {min} أحرف على الأقل.',
  'auth.passwordPattern': 'يجب أن تحتوي كلمة المرور على حروف وأرقام.',
  'auth.passwordHint': 'استخدم {min} حرفاً على الأقل مع مزيج من الحروف والأرقام والرموز.',
  'auth.showPassword': 'إظهار كلمة المرور',
  'auth.hidePassword': 'إخفاء كلمة المرور',
  'auth.keepSignedIn': 'البقاء متصلاً',
  'auth.forgotPassword': 'نسيت كلمة المرور؟',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'تسجيل الدخول',
  'auth.signingIn': 'جارٍ تسجيل الدخول...',
  'auth.signInError': 'فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.',
  'auth.googleError': 'فشل تسجيل الدخول بحساب Google.',
  'auth.noAccount': 'ليس لديك حساب؟',
  'auth.createAccount': 'إنشاء حساب',
  'auth.signUp.title': 'أنشئ حسابك',
  'auth.signUp.subtitle':
    'انضم إلى {site} لإدارة حجوزاتك وحفظ عقاراتك المفضلة والحصول على عروض حصرية.',
  'auth.firstName': 'الاسم الأول',
  'auth.firstNamePlaceholder': 'أدخل اسمك الأول',
  'auth.firstNameRequired': 'الاسم الأول مطلوب.',
  'auth.lastName': 'اسم العائلة',
  'auth.lastNamePlaceholder': 'أدخل اسم عائلتك',
  'auth.lastNameRequired': 'اسم العائلة مطلوب.',
  'auth.mobile': 'رقم الجوال',
  'auth.mobilePlaceholder': 'أدخل رقم الجوال',
  'auth.dialingCode': 'رمز الاتصال بالدولة',
  'auth.mobileRequired': 'رقم الجوال مطلوب.',
  'auth.mobileInvalid': 'يرجى إدخال رقم جوال صالح.',
  'auth.confirmPassword': 'تأكيد كلمة المرور',
  'auth.confirmPasswordPlaceholder': 'أكد كلمة المرور',
  'auth.termsAgree': 'أوافق على',
  'auth.termsRequired': 'يجب الموافقة على الشروط والأحكام وسياسة الخصوصية.',
  'auth.marketingConsent': 'أرغب في تلقّي عروض حصرية وإلهام للسفر من {site}',
  'auth.signUpError': 'تعذر إنشاء الحساب. يرجى المحاولة مرة أخرى.',
  'auth.signUp': 'إنشاء حساب',
  'auth.creatingAccount': 'جارٍ إنشاء الحساب...',
  'auth.createAccountButton': 'إنشاء حساب',
  'auth.alreadyHaveAccount': 'لديك حساب بالفعل؟',
  'auth.passwordMismatch': 'كلمتا المرور غير متطابقتين.',
  'pricing.title': 'ملخص التسعير',
  'pricing.noRoomsSelected': 'لم يتم اختيار غرف. يرجى العودة واختيار الغرف.',
  'pricing.backToAvailability': 'العودة إلى التوافر',
  'pricing.continue': 'متابعة إلى تفاصيل النزيل',
  'property.youSavePercent': 'وفر ({percent}%)',
  'property.includingTaxesFees': '(شامل الضرائب والرسوم)',
  'map.zoomIn': 'تكبير',
  'map.zoomOut': 'تصغير',
  'map.viewFullMap': 'عرض الخريطة بالكامل',
  'booking.progress': 'تقدم الحجز',
  'reservationDetail.resetAria': 'إعادة تعيين حالة الحجز',
  'bookingLookup.title': 'ابحث عن حجزك',
  'bookingLookup.description': 'أدخل رقم مرجع الحجز وبريدك الإلكتروني لعرض أو تعديل أو إلغاء حجزك.',
  'bookingLookup.bookingReference': 'رقم مرجع الحجز',
  'bookingLookup.placeholder': 'مثال: SYD-260815-0001',
  'bookingLookup.lookingUp': 'جارٍ البحث…',
  'bookingLookup.findBooking': 'ابحث عن الحجز',
  'bookingLookup.notFound':
    'لم يُعثر على الحجز. جرّب BK-2026-001، alex.morgan@example.com و Morgan.',
  'cancellation.title': 'إلغاء الحجز',
  'cancellation.property': 'العقار',
  'cancellation.details': 'تفاصيل الإلغاء',
  'cancellation.penalty': 'غرامة الإلغاء',
  'cancellation.refund': 'مبلغ الاسترداد',
  'cancellation.totalPaid': 'إجمالي المدفوع:',
  'cancellation.reasonLabel': 'سبب الإلغاء (اختياري)',
  'cancellation.understand': 'أدرك أن هذا الإجراء لا يمكن التراجع عنه.',
  'cancellation.cancelledDemo':
    'تم إلغاء حجزك في هذه النسخة التجريبية. مبلغ الاسترداد: {{refundAmount}}.',
  'cancellation.confirm': 'تأكيد الإلغاء',
  'cancellation.notFound': 'لم يُعثر على الحجز.',
  'bookingDetails.title': 'تفاصيل الحجز',
  'bookingDetails.notFound': 'لم يُعثر على الحجز.',
  'bookingDetails.checkIn': 'الوصول:',
  'bookingDetails.checkOut': 'المغادرة:',
  'bookingDetails.rooms': 'الغرف',
  'bookingDetails.guest': 'النزيل',
  'bookingDetails.freeCancellationUntil': 'إلغاء مجاني حتى {date}',
  'bookingDetails.total': 'الإجمالي:',
  'reservationDetail.loading': 'جارٍ تحميل حجزك…',
  'reservationDetail.noReference': 'لم يُقدَّم رقم مرجع الحجز.',
  'reservationDetail.loadError': 'تعذر تحميل تفاصيل الحجز.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'جارٍ تحميل المواقع…',
  'common.couldNotLoadLocations': 'تعذر تحميل المواقع',
  'common.searchLocationPlaceholder': 'ابحث عن دولة أو مدينة أو عقار',
  'common.collapse': 'طيّ',
  'common.expand': 'توسيع',
  'map.loadingGoogle': 'جارٍ تحميل خريطة Google…',
  'map.errorGoogle': 'فشل تحميل خرائط Google',
  'map.errorMap': 'فشل تحميل الخريطة.',
  'map.greatLocation': 'موقع ممتاز',
  'home.trust.secureBooking': 'حجز آمن',
  'home.trust.secureBookingDesc': 'معلوماتك آمنة معنا.',
  'home.trust.bestPrice': 'ضمان أفضل سعر',
  'home.trust.bestPriceDesc': 'وجدت سعراً أقل؟ سنطابقه.',
  'home.trust.localSupport': 'دعم على مدار الساعة',
  'home.trust.localSupportDesc': 'نحن هنا للمساعدة في أي وقت.',
  'home.trust.flexibleBooking': 'خيارات مرنة',
  'home.trust.flexibleBookingDesc': 'إلغاء مجاني على الأسعار المحددة.',
  'promotion.memberPromo': 'عرض الأعضاء',
  'promotion.save': 'وفر',
  'property.memberRate': 'سعر الأعضاء',
  'property.hideAmenities': 'إخفاء المرافق',
  'property.showAllAmenities': 'عرض جميع المرافق',
  'property.chooseRatePromo': 'اختر السعر المفضل لديك - أسعار الأعضاء توفّر خصومات حصرية!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-خصم {percent}%',
  'gallery.imageAlt': '{title} صورة {current} من {total}',
  'gallery.thumbnailAlt': 'انتقل إلى الصورة {current} من {total}',
  'gallery.previewAlt': 'معاينة {title}',
  'detail.night_one': 'ليلة',
  'detail.night_other': 'ليالٍ',
  'detail.adult_one': 'بالغ',
  'detail.adult_other': 'بالغون',
  'detail.child_one': 'طفل',
  'detail.child_other': 'أطفال',
  'detail.infant_one': 'رضيع',
  'detail.infant_other': 'رضع',
} as const;
